export default [
	{
		name: 'documenttypes',
		singular: 'entity.documenttype.name',
		plural: 'Dokumentenarten',
	},
	{
		name: 'addresses',
		singular: 'entity.address.name',
		plural: 'Adressen',
	},
	{
		name: 'notestype',
		singular: 'entity.notestype.name',
		plural: 'Notizarten',
	},
]
